import icon01 from '@/assets/icon_01.svg';
import icon11 from '@/assets/icon_11.svg';
import AnalyticsCard from '@/components/analyticsPage/tabPanels/components/initiateCTA/components/generatorModal/components/AnalyticsCard';
import { useTranslation } from 'react-i18next';
import * as amplitude from '@amplitude/analytics-browser';
import { Fragment } from 'react';
import { Transition, TransitionChild, Dialog, DialogPanel, DialogTitle } from '@headlessui/react';

interface GeneratorModalProps {
  open?: boolean;
  closeModal?: () => void;
  handleDataDrawer?: () => void;
  handleIndexDrawer?: () => void;
}

const GeneratorModal = ({
  open = false,
  closeModal,
  handleDataDrawer = () => {},
  handleIndexDrawer = () => {},
}: GeneratorModalProps) => {
  const handleData = () => {
    amplitude.track('analytics_analysis_create_start', { category: 'data' });
    handleDataDrawer();
    closeModal();
  };

  const handleIndex = () => {
    amplitude.track('analytics_analysis_create_start', { category: 'index' });
    handleIndexDrawer();
    closeModal();
  };

  const [t] = useTranslation('analytics');

  return (
    <Transition appear show={open} as={Fragment}>
      <Dialog as="div" className="relative" onClose={closeModal}>
        <TransitionChild
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black/25" style={{ zIndex: 1000 }} />
        </TransitionChild>

        <div className="fixed inset-0 overflow-y-auto" style={{ zIndex: 1000 }}>
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <TransitionChild
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <DialogPanel className="w-full max-w-4xl transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                <DialogTitle
                  as="h3"
                  className="text-lg py-6 font-medium leading-6 text-gray-900 mb-4"
                >
                  <div className="text-center text-2xl font-bold">
                    {t('Select an analytics type')}
                  </div>
                </DialogTitle>

                <div className="mb-6">
                  <div className="flex gap-4 justify-center">
                    <AnalyticsCard
                      img={icon01}
                      title={t('Create a data table')}
                      description={t(
                        'Data analytics provide source data so that users can directly analyze corporate financial and non-financial data in the form of cross-sections and time series after sophisticated normalization and standardization.',
                      )}
                      openAnalyticsDrawer={handleData}
                    />
                    <AnalyticsCard
                      img={icon11}
                      title={t('Create a chart')}
                      description={t(
                        'Index Analytics provide an in-depth analysis function that can analyze companies by ESG topics, and provide long-term and short-term ESG risk indicators.',
                      )}
                      openAnalyticsDrawer={handleIndex}
                    />
                  </div>
                </div>
              </DialogPanel>
            </TransitionChild>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default GeneratorModal;
